import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Cuestionario from './components/Cuestionario';

const Cuestionariox = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
      </Col>
    </Row>
    <Row>
      
      <Cuestionario />
    </Row>
  </Container>
);

export default Cuestionariox;
